import 'url-polyfill';
import '@babel/polyfill';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {auth, AuthService} from './services/auth';
import {AppWrapper} from './components/AppWrapper';

let rendered = false;
let root;
async function render(error) {
    if (rendered) return;
    rendered = true;

    await AuthService.user.catch((error) => error);

    const appContainer = document.getElementById('app');
    if (!appContainer) {
        return;
    }

    root = root || createRoot(appContainer);
    root.render(<AppWrapper error={error}/>);
}

if (!auth.config.providers[0].idToken.expired) {
    render();
} else {
    auth.on('login', (error) => {
        render(error);
    });
}
